// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c0ee005d","453":"b5c16d7b","455":"d133fed0","977":"19e5a7df"}[chunkId] + ".chunk.js";
};